/* tslint:disable */
/* eslint-disable */
/**
 * Bfree API
 * API Documentation for B&Free Project
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    HostResource,
    HostResourceFromJSON,
    HostResourceFromJSONTyped,
    HostResourceToJSON,
} from './';

/**
 * 
 * @export
 * @interface HostResourceDetail
 */
export interface HostResourceDetail {
    /**
     * 
     * @type {HostResource}
     * @memberof HostResourceDetail
     */
    data?: HostResource;
}

export function HostResourceDetailFromJSON(json: any): HostResourceDetail {
    return HostResourceDetailFromJSONTyped(json, false);
}

export function HostResourceDetailFromJSONTyped(json: any, ignoreDiscriminator: boolean): HostResourceDetail {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : HostResourceFromJSON(json['data']),
    };
}

export function HostResourceDetailToJSON(value?: HostResourceDetail | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': HostResourceToJSON(value.data),
    };
}

